/* eslint-disable react-native/no-inline-styles */
import { useNavigation } from "@react-navigation/native"
import { useColor } from "app/theme/getThemes"
import React from "react"
import { View, Text, TouchableOpacity, Image, useWindowDimensions } from "react-native"
import RenderHTML from "react-native-render-html"
import { typography } from "theme"
import { style } from "../screens/Application/Home/styles"

const StampItems = ({ stamps, widths = "100%", isExpired = false }) => {
  const { companyTheme } = useColor()
  const navigation = useNavigation<any>()
  const { width } = useWindowDimensions()

  console.log(isExpired, "isExpired")
  return (
    <TouchableOpacity
      onPress={() => {
        navigation.navigate("stampsDetails", {
          item: stamps,
        })
      }}
      style={[style.stampContainer, { width: widths, opacity: isExpired ? 0.5 : 1 }]}
    >
      {stamps?.stamp_image && (
        <Image
          source={{ uri: stamps?.stamp_image }}
          resizeMode="cover"
          style={[style.stampImage, { width: "100%", height: width / 2.9 }]}
        />
      )}

      <View style={style.stampTextContainer}>
        <Text numberOfLines={2} style={style.title}>
          {stamps?.stamp_name}
        </Text>
        <RenderHTML
          contentWidth={width >= 800 ? 800 : width}
          defaultTextProps={{
            style: {
              fontFamily: typography.primary.normal,
            },
          }}
          source={{
            html: `${stamps?.stamp_description}`,
          }}
        />
        <View style={{ marginTop: 5 }}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Text style={style.stampCountText}>
              {Math.floor(Number(stamps?.total_stamp_count) / stamps.stamp_required)} voucher(s)
              redeemable
            </Text>
            <Text style={style.stampCountText}>
              ({stamps.total_stamp_count} / {Number(stamps.stamp_required)})
            </Text>
          </View>

          <View style={style.stampProgressContainer}>
            {Array.from({ length: stamps.stamp_required }).map((_, index) => (
              <View
                key={index}
                style={[
                  style.stampSegment,
                  {
                    width: `${
                      Number(stamps.stamp_required) === 1
                        ? 100
                        : 100 /
                          (Number(stamps.stamp_required) +
                            (Number(stamps.stamp_required) <= 4 ? 0.3 : 2))
                    }%`,
                  },
                  index < stamps.total_stamp_count && {
                    backgroundColor: companyTheme.first, // Adjusted to use your theme colors
                  },
                ]}
              />
            ))}
          </View>
        </View>
      </View>
      {isExpired === true && (
        <Image
          source={require("../../assets/expired.png")}
          resizeMode="contain"
          style={[
            style.stampImage,
            {
              width: 80,
              height: 80,
              position: "absolute",
              right: 10,
              bottom: 20,
              zIndex: 999,
            },
          ]}
        />
      )}
    </TouchableOpacity>
  )
}

export default StampItems
